import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'mb-po-upload-confirmation',
  templateUrl: './po-upload-confirmation.component.html',
  styleUrls: ['./po-upload-confirmation.component.scss']
})
export class PoUploadConfirmationComponent {

  constructor (protected router: Router) { }

  navigateToHomePage () {
    return this.router.navigate(['/'])
  }
 }
